import { Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";

import { routes } from "config/routes";
import { Page } from "shared/components/Page";
import { NavigationHeader } from "ui/NavigationHeader/NavigationHeader";
import { TitleM } from "ui/Typography/Typography";
import { formatDate } from "utils/formats";

import {
  BatteryCountCard,
  BatteryTasksLoading,
  BatteryTasksLoadingError,
  NoBatteryCountScheduled,
} from "../components";
import { useGetRecurrentTasksForHubQuery } from "../queries/tasks.generated";
import { RECURRING_TASK_TYPE } from "../utils/constants";

export function BatteryCountListPage() {
  const intl = useIntl();
  const navigate = useNavigate();

  const {
    loading: loadingAllTasks,
    data: allTasksData,
    error: allTasksError,
  } = useGetRecurrentTasksForHubQuery({
    variables: { input: { type: RECURRING_TASK_TYPE } },
    fetchPolicy: "network-only",
  });

  const allTasksCount = allTasksData?.getRecurrentTasksForHub.recurrentTasks.length || 0;

  // All the tasks have the same due date and start date, so we can take it from the first one
  const startDate = allTasksData?.getRecurrentTasksForHub.recurrentTasks[0]?.startDate;
  const dueDate = allTasksData?.getRecurrentTasksForHub.recurrentTasks[0]?.dueDate;

  return (
    <Page isCentered isFull isBgGrey justifyContent="flex-start">
      <NavigationHeader
        title={intl.formatMessage({ id: "pages.inventory.battery-count-page.title" })}
        onClickGoBack={() => navigate(routes.inventory.root)}
      />

      <Box position="relative" w="full" h="full" py="s200" bg="grey.150" overflow="auto">
        {loadingAllTasks && <BatteryTasksLoading />}
        {allTasksError && <BatteryTasksLoadingError />}
        {!allTasksError && allTasksCount === 0 && <NoBatteryCountScheduled />}
        {!allTasksError && allTasksCount > 0 && (
          <>
            {startDate && dueDate && (
              <TitleM px="s200" mb="s200">{`${formatDate(startDate)} - ${formatDate(
                dueDate,
              )}`}</TitleM>
            )}
            {allTasksData?.getRecurrentTasksForHub.recurrentTasks.map((task) => (
              <BatteryCountCard
                key={task.id}
                taskId={task.id}
                status={task.status}
                count={task.customAttributes?.count ?? null}
                employeeId={task.updatedBy ?? null}
                startDate={task.startDate}
                dueDate={task.dueDate}
                updatedAt={task.updatedAt}
              />
            ))}
          </>
        )}
      </Box>
    </Page>
  );
}
